import React from "react";
import tw from "tailwind-styled-components";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";

function KPIs({ data, setIsShowAnalytics, canViewFinance }) {
  const navigate = useNavigate();
  // const metrics = [
  //   { label: "Today's Lead", value: data?.todayLeads, link: "/leads" },
  //   { label: "Active Leads", value: data?.activeLeads, link: "/leads" },
  //   { label: "Today's Followup", value: data?.todayFollowup, link: "/leads/followups" },
  //   { label: "Site Visit", value: data?.todayVisits, link: "/leads/visits", color: "text-green-600" },
  //   { label: "Bookings", value: data?.totalBookings, link: "/bookings", color: "text-amber-600" },
  //   { label: "Vacant Beds", value: data?.vacantBeds, link: "/vacancy-by-property", color: "text-rose-600" },
  //   // { label: "Bookings", value: data?.todayBookingTenants, link: "/tenants/active", color: "text-sky-600" },
  // ];
  const totalBeds =
    (data?.occupiedBeds || 0) + (data?.vacantBeds || 0);
  const vacancyPercent = totalBeds
    ? ((data.vacantBeds / totalBeds) * 100).toFixed(2)
    : 0;
  const metrics = [
    {
      label: "Total Leads",
      value: data?.totalLeads,
      link: "/leads",
      //color: "text-sky-600",
      //bg: "bg-sky-50",
    },
    {
      label: "New Leads",
      value: data?.newLeads,
      link: "/leads",
      color: "text-sky-600",
      bg: "bg-sky-50",
    },
    // {
    //   label: "Active Leads",
    //   value: data?.activeLeads,
    //   link: "/leads",
    //   color: "text-violet-600",
    //   bg: "bg-violet-50",
    // },
    {
      label: "Today's Follow-up",
      value: data?.todayFollowup,
      link: "/leads/followups",
      color: "text-indigo-600",
      bg: "bg-indigo-50",
    },
    {
      label: "Site Visits",
      value: data?.todayVisits,
      link: "/leads/visits",
      color: "text-emerald-600",
      bg: "bg-emerald-50",
    },
    {
      label: "Bookings",
      value: data?.totalBookings,
      link: "/bookings",
      color: "text-purple-600",
      bg: "bg-amber-50",
    },
    {
      label: "Vacant Beds",
      value: data?.vacantBeds,
      vacancyPercent: vacancyPercent,
      link: "/vacancy-by-property",
      color: "text-rose-600",
      bg: "bg-rose-50",
    },
  ];

  return (
    <Container>
      <HeaderRow>
        <MetricsRow>
          <MetricsScroll>
            {metrics.map((item, index) => (
              <Metric
                key={index}
                onClick={() => navigate(item.link)}
              >
                <MetricLabel>{item.label}</MetricLabel>

                <MetricValue className={item.color || "text-gray-900"}>
                  {item.value ?? 0}
                  {item.vacancyPercent !== undefined && (
                    <VacancyPercent>
                      ({item.vacancyPercent}%)
                    </VacancyPercent>
                  )}
                  <Arrow />
                </MetricValue>
              </Metric>
            ))}
          </MetricsScroll>
        </MetricsRow>
        {canViewFinance &&
          <ArrowStatic onClick={() => {
            setIsShowAnalytics(true);
          }}>
            →
          </ArrowStatic>
        }
      </HeaderRow>
      {/* <ContextNote>
        Date filter does not affect these values.
      </ContextNote> */}
    </Container>
  );
}

const Container = tw.div`
  mt-2 md:mt-6
  bg-white rounded-lg shadow-sm
  px-4 py-4 md:px-6
`;

const HeaderRow = tw.div`
  flex items-start justify-between
  w-full
`;

const MetricsScroll = tw.div`
  flex gap-2
  overflow-x-auto
  scrollbar-hide
  justify-end
  pb-1
  grid md:grid-cols-7 xl:grid-cols-8 grid-cols-4
`;

const Metric = tw.div`
  min-w-[110px]
  flex-shrink-0
  cursor-pointer
  group
`;

const MetricLabel = tw.div`
  text-[9px] md:text-[11px] uppercase tracking-wide text-gray-500
  whitespace-nowrap
`;

const MetricValue = tw.div`
  flex items-center gap-1
  text-lg font-semibold
  transition-colors
`;

const Arrow = tw(IoIosArrowForward)`
  text-gray-400 text-xs
  opacity-0 group-hover:opacity-100
  transition-opacity
`;

const MetricsRow = tw.div`
  flex-1 
   min-w-0
`;

const ContextNote = tw.div`
  mt-0
  -mb-2
  pr-0
  text-[10px]
  text-gray-300
  text-right
  hidden lg:block
  leading-tight
`;

const ArrowStatic = tw.span`
  text-gray-400 text-lg
  cursor-pointer
  hover:text-gray-600
  transition
  ml-4
  flex-shrink-0
  self-start
`;

const VacancyPercent = tw.span`
  text-[10px] md:text-[11px]
  font-medium
  text-gray-400
  ml-0.5
`;

export default KPIs;